import styled from 'styled-components';
import colors from '../../helpers/colors';
import mediaQuery from '../../helpers/mediaQuery';
import LazyImg from '../LazyImg';

export type Background = 'light' | 'dark';

export const StyledLogo = styled(LazyImg)`
  /* Allow users of this component to be able to style the image and have the height affect
  the size of the image itself, rather than including the extra padding that we add here.*/
  box-sizing: content-box;

  padding: 6px 4px;

  /* Add a transparent border when there is no outline to prevent 'jumping' when the LinkWrapper is focussed. */
  border: solid 2px transparent;

  ${mediaQuery.tabletPortrait`
    padding: 10px 6px;
  `}

  ${mediaQuery.tabletLandscape`
    padding: 12px 6px;
  `}
`;

export const LinkWrapper = styled.a<{ background: Background }>`
  display: block;

  /* Removes the little bit of space below the image */
  line-height: 0;
  outline: none;

  &:focus-visible {
    ${StyledLogo} {
      border-color: ${({ background }) =>
        background === 'light' ? colors.core02 : colors.neutral08};
      border-radius: 8px;
    }
  }
`;

export const LogoLinkWrapper = styled.div`
  /* This is to cancel out the padding and border that were added to the image, so that it positions as
  expected for any components that use this. */
  margin: -8px -6px;

  ${mediaQuery.tabletPortrait`
    margin: -12px -8px;
  `}

  ${mediaQuery.tabletLandscape`
    margin: -14px -8px;
  `}
`;
